document.addEventListener('DOMContentLoaded', function () {

  // header shadow on scroll
  const header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 8);
    });
  }

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    const a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('open');
        i.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  // scroll reveal
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // ---- Real Shopify cart (Cart AJAX API) ----
  const cartBadge = document.getElementById('cartBadge');
  const toastEl = document.getElementById('toast');

  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toastEl.classList.remove('show'), 2400);
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (!cartBadge) return;
        cartBadge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        cartBadge.textContent = cart.item_count;
      })
      .catch(() => {});
  }
  refreshCartBadge();

  document.querySelectorAll('.add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(r => {
          if (!r.ok) throw new Error('Could not add to cart');
          return r.json();
        })
        .then(() => {
          showToast((form.dataset.productName || 'Item') + ' added to cart');
          refreshCartBadge();
        })
        .catch(() => showToast('Sorry, that item is out of stock or unavailable.'));
    });
  });

  // Newsletter signup — requires a connected email app (e.g. Klaviyo, Shopify Email)
  // to actually store subscribers. This just confirms the click for now.
  const nlForm = document.querySelector('.nl-form');
  if (nlForm) {
    nlForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = nlForm.querySelector('input[type="email"]');
      if (input && input.value) {
        showToast("Thanks! Connect an email app to start actually saving signups.");
        input.value = '';
      }
    });
  }

});
